import React from 'react';
import './Header.scss';
import Menu from '../Menu/Menu';
import Img from '../../atoms/Img/Img';
import logo from '../../../assets/images/grainger-logo-text.svg';

export default function Header() {
  return (
    <div className="header">
      <Menu />
      <div className="header__title">
        <a
          aria-label="Grainger home page"
          href="/"
        >
          <Img
            alt="grainger"
            src={logo}
            color="color: rgb(0, 55, 84);"
          />
        </a>
      </div>
    </div>
  );
}
